/**
 * Some LR sontents loads slower, so scrollTo misscalculates the position.
 * To fix it, this function is written to not interrupt the process.
 */

window.addEventListener("DOMContentLoaded", () => {
  if (window.location.hash) {
    const currHash = window.location.hash;
    /**
     * @description 
     * In some cases blog series is returned later than document is loaded. 
     * For those cases, use timeout for new call
     * @param { String } hash
     * @returns bool
     */
    function ifIdWithHash(hash) {
      if (document.querySelector(hash)) {
        if (document.getElementById(window.location.hash.substring(1))) {
          const hash = window.location.hash.substring(1);
          const target = document.getElementById(hash).getBoundingClientRect().top;
          const offsetPosition = target - document.getElementById(hash).scrollHeight;
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        }
        return true;
      } else {
        return false;
      }
    }

    if (ifIdWithHash(currHash)) {
    } else {
      setTimeout(() => {
        ifIdWithHash(currHash);
      }, 500);
    }
  }
});
